module.exports = __webpack_public_path__ + "static/media/leaf.6c61bd34.svg";